import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActionCoCardModel, ActionCoDevisModel, ESIGNSTATE } from '../../../models';
import { HttpService, CoreService } from '../../../services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co-esign',
  templateUrl: './action-co-esign.component.html',
  styleUrls: ['./action-co-esign.component.css']
})

export class ActionCoESignComponent {
  @Input() model: ActionCoCardModel;
 

  public bo: string = '0';
  public mode: string = 'ALL';
  public identDevis: string = '0';
  public isInactif: boolean = false;
  
  constructor(
    protected http: HttpService,
    protected indParam: CoreService,
  ) { }


  public ngOnInit(): void {

    this.http.getHttp<ActionCoDevisModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Devis/INITESIGN/${this.model.idActionCo}/`).subscribe((data: ActionCoDevisModel) => {
      if (!data.HasError) {        
        this.identDevis = data.Devis.Ident;
        this.isInactif = data.Devis.StateESign == ESIGNSTATE.INACTIF;
      }
    });

  }

}
